import React from "react";
import ReactTable from "react-table";

import "./PointsHistoryModal.sass";
import { pointsHistoryReasons } from "../../../constants/pointsHistoryReasons";

export const PointsHistoryModal = ({ pointsHistory, email, points }) => {
  const getLabelStyle = () => ({
    style: {
      marginTop: '6px',
    },
  });
  const columns = [
    {
      Header: "Date&Time",
      width: 200,
      Cell: ({ row: { _original: { createdAtUtc } } }) => {
        const date = new Date(createdAtUtc);
        
        return <>{
          date.toLocaleDateString()
        } {date.toLocaleTimeString()}</>
      },
      getProps: getLabelStyle,
    },
    {
      Header: "Point Changes",
      accessor: "pointChanges",
      width: 120,
      getProps: getLabelStyle,
    },
    {
      Header: "Reason",
      width: 120,
      Cell: ({ row: { _original: { reason } } }) => {
        const label = pointsHistoryReasons.find(r => r.value === reason).label || "N/A"
        
        return <span>{label}</span>
      },
      getProps: getLabelStyle,
    },
  ];

  return (
    <section className="history-modal">
      <h4 className="history-modal__title">Points history</h4>

      <div className="history-modal__info-list">
        <div className="history-modal__info-item"><strong>Target member:</strong> {email}</div>
        <div className="history-modal__info-item"><strong>Points:</strong> {points}</div>
      </div>

      <ReactTable
        data={pointsHistory}
        columns={columns}
        defaultPageSize={100000}
        showPagination={false}
        minRows={0}
        sortable={false}
        resizable={false}
      />
    </section>
  )
}